<template>
  <el-dialog :title="`图片裁剪工具(宽高比例[${fixedNumber[0]}:${fixedNumber[1]}])`"
             :visible="visible"
             :show-close="false"
             append-to-body=""
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             width="800px"
             center>
    <div class="crop-wrap">
      <vueCropper ref="cropper"
                  :img="img"
                  :outputSize="option.outputSize"
                  :outputType="option.outputType"
                  :info="option.info"
                  :canScale="option.canScale"
                  :autoCrop="option.autoCrop"
                  :autoCropWidth="autoCropWidth"
                  :autoCropHeight="autoCropHeight"
                  :fixed="option.fixed"
                  :fixedNumber="fixedNumber"
                  :full="option.full"
                  :fixedBox="option.fixedBox"
                  :canMove="option.canMove"
                  :canMoveBox="option.canMoveBox"
                  :original="option.original"
                  :centerBox="option.centerBox"
                  :high="option.high"
                  :infoTrue="option.infoTrue"
                  :maxImgSize="option.maxImgSize"
                  :enlarge="option.enlarge"
                  :mode="option.mode"
                  @realTime="realTime"
                  @imgLoad="imgLoad"
                  @cropMoving="cropMoving"
                  @imgMoving="imgMoving"></vueCropper>
    </div>
    <div class="preview">
      <!-- <div class="image-large"
        :style="preview.div">
        <img :src="preview.url"
          :style="preview.img">
      </div>
      <div class="image-medium"
        :style="preview.div">
        <img :src="preview.url"
          :style="preview.img">
      </div> -->
      <div class="image-small"
           :style="preview.div">
        <img :src="preview.url"
             :style="preview.img">
      </div>
    </div>
    <div slot="footer">
      <el-button size="small"
                 :loading="loading"
                 @click="cancel">取消</el-button>
      <el-button size="small"
                 :loading="loading"
                 type="primary"
                 @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper'
export default {
  name: 'CropperModal',
  components: { VueCropper },
  props: {
    loading: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    img: { type: [String, Blob, null, File], default: '' },
    autoCropWidth: { type: Number, default: 200 },
    autoCropHeight: { type: Number, default: 200 },
    fixedNumber: { type: Array, default () { return [1, 1] } }
  },
  data () {
    return {
      option: {
        // img: '', // 裁剪图片的地址 url || base64 || blob
        outputSize: 1, // 裁剪生成图片的质量 0.1 - 1
        outputType: 'png', // 裁剪生成图片的格式 jpeg || png || webp
        info: true, // 裁剪框的大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 200, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixed: true, // 是否开启截图框宽高固定比例
        // fixedNumber: [1, 1], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        fixedBox: false, // 固定截图框大小 不允许改变
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        high: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        maxImgSize: 2000, // 限制图片最大宽度和高度
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: 'contain' // 图片默认渲染方式
      },
      preview: {}
    }
  },
  methods: {
    realTime (data) {
      console.log(data)
      this.preview = data
    },
    imgLoad (msg) {
      console.log(msg)
    },
    cropMoving (data) {
      console.log(data)
    },
    imgMoving (data) {
      console.log(data)
    },
    cancel () {
      // this.$refs.cropper.refresh()
      this.$emit('crop:cancel')
    },
    submit () {
      this.$refs.cropper.getCropBlob(file => {
        this.$emit('crop:submit', { file })
      })
    }
  }

}
</script>
<style lang="stylus" scoped>
.crop-wrap {
  width: 100%;
  height: 422px;
}

.preview {
  margin-top: 10px;
  display: flex;

  .image-large {
    overflow: hidden;
  }

  .image-medium {
    overflow: hidden;
    zoom: 0.7;
  }

  .image-small {
    overflow: hidden;
    zoom: 0.5;
  }
}
</style>
